var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "refresh_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#refresh_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20c-2.233 0-4.125-.775-5.675-2.325C4.775 16.125 4 14.233 4 12c0-2.233.775-4.125 2.325-5.675C7.875 4.775 9.767 4 12 4c1.15 0 2.25.237 3.3.713A7.623 7.623 0 0 1 18 6.75V5c0-.283.096-.52.288-.713A.968.968 0 0 1 19 4c.283 0 .52.096.712.287.192.192.288.43.288.713v5c0 .283-.096.52-.288.713A.968.968 0 0 1 19 11h-5a.968.968 0 0 1-.713-.287A.968.968 0 0 1 13 10c0-.283.096-.52.287-.713A.968.968 0 0 1 14 9h3.2a5.836 5.836 0 0 0-2.188-2.2A5.928 5.928 0 0 0 12 6c-1.667 0-3.083.583-4.25 1.75C6.583 8.917 6 10.333 6 12c0 1.667.583 3.083 1.75 4.25C8.917 17.417 10.333 18 12 18c1.133 0 2.17-.288 3.113-.863a5.953 5.953 0 0 0 2.187-2.312 1.07 1.07 0 0 1 .563-.487c.241-.092.487-.096.737-.013a.898.898 0 0 1 .575.525c.117.267.108.517-.025.75a8.075 8.075 0 0 1-2.925 3.2C14.958 19.6 13.55 20 12 20Z",
    fill: "currentColor"
  }))));
};
export default SvgRefresh;